module.exports = __webpack_public_path__ + "fontawesome-webfont.af7ae505a9eed503f8b8.woff2";


//////////////////
// WEBPACK FOOTER
// ./~/font-awesome/fonts/fontawesome-webfont.woff2?v=4.7.0
// module id = 810
// module chunks = 53